/* Account for the actual intro and header above the first homepage hero. */
(() => {
  if (window.friendsHomeHeroObserver) return;
  const update = () => {
    const hero = document.querySelector('[data-friends-first-hero]');
    if (!hero) return;
    const top = hero.getBoundingClientRect().top + window.scrollY;
    hero.style.setProperty('--friends-hero-available-height', `${Math.max(320, window.innerHeight - top - 24)}px`);
  };
  const observer = new ResizeObserver(update);
  const connect = () => {
    observer.disconnect();
    const hero = document.querySelector('[data-friends-first-hero]');
    if (!hero) return;
    document.querySelectorAll('.shopify-section').forEach(section => {
      if (section.contains(hero) || (section.compareDocumentPosition(hero) & Node.DOCUMENT_POSITION_FOLLOWING)) observer.observe(section);
    });
    update();
  };
  window.friendsHomeHeroObserver = observer;
  window.addEventListener('resize', update, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  document.addEventListener('shopify:section:reorder', connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
})();
